import { h } from "preact";

import classname from "../../../foundation/utils/classname";

import styles from "./Meter.module.css";

const HIGH_VALUE = 90;
const LOW_VALUE = 50;
const OPTIMUM_VALUE = LOW_VALUE - 1;
const MIN_VALUE = 0;
const MAX_VALUE = 100;

interface Props {
    max?: number;
    value: number;
}

export default function Meter({
    max = MAX_VALUE,
    value
}: Props) {
    const valuePercent = (value * MAX_VALUE) / max;

    return (
        <meter
            class={classname(styles.meter, {
                [styles.suboptimum]: valuePercent > LOW_VALUE,
                [styles.evenLessGood]: valuePercent > HIGH_VALUE
            })}
            min={MIN_VALUE}
            max={MAX_VALUE}
            optimum={OPTIMUM_VALUE}
            low={LOW_VALUE}
            high={HIGH_VALUE}
            value={valuePercent}>
            {value} of {max}
        </meter>
    );
}

export { LOW_VALUE as METER_LOW_VALUE };
